import React from 'react';
import { FileIconBase } from './_base';
const AudioFileIcon = (props) => (React.createElement(FileIconBase, Object.assign({}, props, { defaultColor: "#1AA39C", label: "MP3" })));
export default AudioFileIcon;
